import { PaymentOptionsProps, PaymentSummaryType } from '@/types/payment';

// Payment status enum
export enum PaymentStatus {
  IDLE = 'idle',
  SUCCESS = 'success',
  FAILED = 'failed',
}

// Locale content types
export interface PaymentStatusContent {
  successTitle: string;
  successDescription: string;
  failTitle: string;
  failDescription: string;
  totalPaid: string;
  referenceNo: string;
  done: string;
  retry: string;
}

export interface TransferPaymentContent {
  payDescription: string;
  paymentMethod: string;
  bankTransfer: string;
  directTransfer: string;
  cardPayment: string;
  summary: string;
  cardPaymentDrawer: {
    heading: string;
    subHeading: string;
    errorMessage: string;
  };
}

export interface PaymentLocaleContent {
  transferPayment: TransferPaymentContent;
  paymentStatus: PaymentStatusContent;
}

// Component Props
export interface PaymentHeaderProps {
  amount: number;
  currency: string;
  description: string;
}

export interface PaymentMethodButtonsProps {
  content: TransferPaymentContent;
  cyberSourceConfig?: PaymentOptionsProps['cyberSourceConfig'];
  directDebitConfig?: PaymentOptionsProps['directDebitConfig'];
  stripeConfig?: PaymentOptionsProps['stripeConfig'];
  isCSPaymentLoading: boolean;
  onCyberSourceClick: () => void;
  onDirectDebitClick: () => void;
  onStripeClick: () => void;
}

export interface PaymentSummaryListProps {
  title: string;
  items: PaymentSummaryType[];
  defaultCurrency: string;
}

export interface StripePaymentDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  content: TransferPaymentContent['cardPaymentDrawer'];
  isLoading: boolean;
  clientSecret?: string | null;
  stripePromise: ReturnType<typeof import('@stripe/stripe-js').loadStripe> | null;
  onSuccess: (result: unknown) => void;
  onFailure: (error: unknown) => void;
  paymentId: string;
}

// Hook return type
export interface UsePaymentOptionsReturn {
  isDrawerOpen: boolean;
  isCSPaymentLoading: boolean;
  stripePromise: ReturnType<typeof import('@stripe/stripe-js').loadStripe> | null;
  loadingPaymentIntent: boolean;
  paymentIntentClientSecret: string | null;
  handleCyberSourcePayment: () => void;
  handleStripeDrawerOpen: () => void;
  handleStripeDrawerClose: () => void;
  handlePaymentSuccess: (result: unknown) => void;
  handlePaymentFailure: (error: unknown) => void;
}

// Re-export for convenience
export type { PaymentOptionsProps, PaymentSummaryType };
